webpackJsonp([1],{

/***/ "0XXo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2N6V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6mFY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AK5/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Drpp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GeVJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HBB0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HjtI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ItQ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JFLh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jsud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var actions_namespaceObject = {};
__webpack_require__.d(actions_namespaceObject, "signUpUser", function() { return actions_signUpUser; });
__webpack_require__.d(actions_namespaceObject, "signInUser", function() { return actions_signInUser; });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.css
var dist_vuetify = __webpack_require__("QCv7");
var dist_vuetify_default = /*#__PURE__*/__webpack_require__.n(dist_vuetify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/partials/HeaderPartial.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var HeaderPartial = ({
  name: 'HeaderPartial',
  data: function data() {
    return {
      fixed: false,
      clipped: true,
      sideNav: false,
      title: 'Smolin BudgetPlan',
      drawer: true
    };
  },

  computed: extends_default()({
    menuItems: function menuItems() {
      var menuItems = [{
        icon: '',
        title: 'Unternehmen',
        link: 'company'
      }, {
        icon: '',
        title: 'Lösungen',
        link: 'solutions'
      }, {
        icon: '',
        title: 'Beratung',
        link: 'consulting'
      }, {
        icon: '',
        title: 'Service',
        link: 'service'
      }, {
        icon: '',
        title: 'Kontakt',
        link: 'contact'
      }];
      if (this.loggedIn) {
        //   menuItems.push({
        //     icon: 'supervisor_account',
        //     title: 'Profile',
        //     link: 'Profile'
        //   })
        // } else {
        //   menuItems.push({
        //     icon: 'face',
        //     title: 'Register',
        //     link: 'SignUp'
        //   })

        //   menuItems.push({
        //     icon: 'lock_open',
        //     title: 'Login',
        //     link: 'SignIn'
        //   })
      }

      return menuItems;
    }
  }, Object(vuex_esm["b" /* mapGetters */])({
    userId: 'userId',
    loggedIn: 'loggedIn'
  }), {
    userIsAuthenticated: function userIsAuthenticated() {
      return false;
    }
  }),
  methods: {
    home: function home() {
      this.$router.push({
        path: 'home'
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75104fa5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/HeaderPartial.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('v-navigation-drawer',{attrs:{"temporary":"","fixed":"","disable-resize-watcher":"","clipped":_vm.clipped,"app":""},model:{value:(_vm.sideNav),callback:function ($$v) {_vm.sideNav=$$v},expression:"sideNav"}},[_c('v-list',_vm._l((_vm.menuItems),function(item,index){return _c('v-list-tile',{key:index,attrs:{"value":"true","router":"","to":item.link}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}})],1)],1)}))],1),_vm._v(" "),_c('v-toolbar',{staticClass:"blue-grey darken-2",attrs:{"dark":"","fixed":"","app":"","clipped-left":_vm.clipped}},[_c('v-toolbar-side-icon',{staticClass:"hidden-sm-and-up",nativeOn:{"click":function($event){$event.stopPropagation();_vm.sideNav = !_vm.sideNav}}}),_vm._v(" "),_c('v-toolbar-title',{attrs:{"router":"","to":_vm.home}},[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_vm._v("Smolin BudgetPlan")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-xs-only"},_vm._l((_vm.menuItems),function(item,index){return _c('v-btn',{key:index,attrs:{"flat":"","router":"","to":item.link}},[(item.icon)?_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(item.icon))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])],1)}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var partials_HeaderPartial = (esExports);
// CONCATENATED MODULE: ./src/components/partials/HeaderPartial.vue
function injectStyle (ssrContext) {
  __webpack_require__("0XXo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  HeaderPartial,
  partials_HeaderPartial,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_partials_HeaderPartial = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-cookie-law/dist/vue-cookie-law.js
var vue_cookie_law = __webpack_require__("xvGj");
var vue_cookie_law_default = /*#__PURE__*/__webpack_require__.n(vue_cookie_law);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/PoweredByWidget.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PoweredByWidget = ({
  name: 'PoweredByWidget',
  data: function data() {
    return {
      brands: [{
        image: '/static/images/vendor/logo.png',
        title: 'VueJs',
        tip: 'The Progressive JavaScript Framework.',
        link: 'https://vuejs.org/'
      }, {
        image: '/static/images/vendor/logo.svg',
        title: 'Vuetify',
        tip: 'Material Component Framework.',
        link: 'https://vuetify.com/'
      }, {
        image: '/static/images/vendor/d3.png',
        title: 'D3',
        tip: 'Data-Driven Documents.',
        link: 'https://d3js.org/'
      }, {
        image: '/static/images/vendor/dotnet_logo.png',
        title: 'dotnet',
        tip: '.NET Foundation',
        link: 'https://d3js.org/'
      }, {
        image: '/static/images/vendor/small_v.png',
        title: 'docker',
        tip: 'Build, Ship, Run',
        link: 'https://d3js.org/'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a5f972","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PoweredByWidget.vue
var PoweredByWidget_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"poweredby"}},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.brands),function(brand,index){return _c('span',{key:index},[_c('a',{attrs:{"href":brand.link,"target":"_blank","title":brand.tip}},[_c('img',{attrs:{"src":brand.image}})])])})],2)}
var PoweredByWidget_staticRenderFns = []
var PoweredByWidget_esExports = { render: PoweredByWidget_render, staticRenderFns: PoweredByWidget_staticRenderFns }
/* harmony default export */ var widgets_PoweredByWidget = (PoweredByWidget_esExports);
// CONCATENATED MODULE: ./src/components/widgets/PoweredByWidget.vue
function PoweredByWidget_injectStyle (ssrContext) {
  __webpack_require__("HjtI")
}
var PoweredByWidget_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PoweredByWidget___vue_template_functional__ = false
/* styles */
var PoweredByWidget___vue_styles__ = PoweredByWidget_injectStyle
/* scopeId */
var PoweredByWidget___vue_scopeId__ = "data-v-38a5f972"
/* moduleIdentifier (server only) */
var PoweredByWidget___vue_module_identifier__ = null
var PoweredByWidget_Component = PoweredByWidget_normalizeComponent(
  PoweredByWidget,
  widgets_PoweredByWidget,
  PoweredByWidget___vue_template_functional__,
  PoweredByWidget___vue_styles__,
  PoweredByWidget___vue_scopeId__,
  PoweredByWidget___vue_module_identifier__
)

/* harmony default export */ var components_widgets_PoweredByWidget = (PoweredByWidget_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/partials/FooterPartial.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var FooterPartial = ({
  components: {
    PoweredByWidget: components_widgets_PoweredByWidget,
    CookieLaw: vue_cookie_law_default.a
  },
  data: function data() {
    return {
      footerItems: [{
        icon: '',
        title: 'Impressum',
        link: 'legal'
      }, {
        icon: '',
        title: 'Datenschutz',
        link: 'privacy'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-684fe732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FooterPartial.vue
var FooterPartial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"fixed":true,"app":""}},[_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear())+" Smolin BudgetPlan GmbH")]),_vm._v(" "),_c('div',{staticClass:"ml-2 mr-2",attrs:{"id":"footerNav"}},_vm._l((_vm.footerItems),function(item,index){return _c('router-link',{key:index,staticClass:"pr-2",attrs:{"to":item.link}},[_vm._v(_vm._s(item.title))])})),_vm._v(" "),_c('cookie-law',{attrs:{"theme":"dark-lime","buttonText":"Akzeptieren"}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n         Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu.\n          Weitere Informationen zu Cookies erhalten Sie in unserer "),_c('router-link',{attrs:{"to":"privacy"}},[_vm._v("Datenschutzerklärung")])],1)])],1)}
var FooterPartial_staticRenderFns = []
var FooterPartial_esExports = { render: FooterPartial_render, staticRenderFns: FooterPartial_staticRenderFns }
/* harmony default export */ var partials_FooterPartial = (FooterPartial_esExports);
// CONCATENATED MODULE: ./src/components/partials/FooterPartial.vue
function FooterPartial_injectStyle (ssrContext) {
  __webpack_require__("6mFY")
}
var FooterPartial_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FooterPartial___vue_template_functional__ = false
/* styles */
var FooterPartial___vue_styles__ = FooterPartial_injectStyle
/* scopeId */
var FooterPartial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FooterPartial___vue_module_identifier__ = null
var FooterPartial_Component = FooterPartial_normalizeComponent(
  FooterPartial,
  partials_FooterPartial,
  FooterPartial___vue_template_functional__,
  FooterPartial___vue_styles__,
  FooterPartial___vue_scopeId__,
  FooterPartial___vue_module_identifier__
)

/* harmony default export */ var components_partials_FooterPartial = (FooterPartial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
  components: {
    HeaderPartial: components_partials_HeaderPartial,
    FooterPartial: components_partials_FooterPartial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-067b41a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('header-partial'),_vm._v(" "),_c('v-content',{},[_c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('footer-partial')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("JFLh")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HomePage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HomePage = ({
  data: function data() {
    return {
      name: 'HomePage',
      sliders: [{
        title: 'Softwareentwicklung',
        short: 'Individuelle Software oder Standartsoftware genau auf Ihre Bedürfnisse angepasst.',
        text: 'Individuelle Software oder Standartsoftware genau auf Ihre Bedürfnisse angepasst. Auf der Basis unserer umfassenden Erfahrung entwickeln wir schnell, effizient und kostengünstig.',
        src: '/static/images/carousel/slide_a_900x500.jpg',
        style: 'blue',
        link: 'solutions'
      }, {
        title: 'Beratung',
        short: 'Fachkundige Beratung für optimale Software.',
        text: 'Fachkundige Beratung für optimale Software. Profitieren Sie von unserem Know-How und unserer Marktübersicht bei Fragen und Problemen bei IT-Prozessen und IT-Systemen.',
        src: '/static/images/carousel/slide_b_900x500.jpg',
        style: 'green',
        link: 'consulting'
      }, {
        title: 'Service',
        short: 'Wir sind für Sie da! Fachkundiger Service bei Problemen und Fragen',
        text: 'Wir sind für Sie da! Hohe Produktqualität und ein optimaler Service gehören zusammen. Neben einer qualifizierten Hotline steht unseren Kunden ein spezieller Supportbereich zur Verfügung.',
        src: '/static/images/carousel/slide_c_900x500.jpg',
        style: 'yellow darken-3',
        link: 'service'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e880f27a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage.vue
var HomePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-carousel',_vm._l((_vm.sliders),function(slide,index){return _c('v-carousel-item',{key:index,attrs:{"src":slide.src}},[_c('h1',{attrs:{"color":slide.style}},[_vm._v(_vm._s(slide.title))]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(slide.short))]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","dark":"","color":slide.style,"to":slide.link}},[_vm._v("Mehr erfahren »")])],1)])}))],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.sliders),function(slide,index){return _c('v-flex',{key:index,attrs:{"xs4":""}},[_c('v-card',[_c('v-card-text',[_c('h2',[_vm._v(_vm._s(slide.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(slide.text))])]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","round":"","color":slide.style,"to":slide.link}},[_vm._v("Mehr erfahren »")]),_vm._v(" "),_c('v-spacer')],1)],1)}))],1)],1)}
var HomePage_staticRenderFns = []
var HomePage_esExports = { render: HomePage_render, staticRenderFns: HomePage_staticRenderFns }
/* harmony default export */ var components_HomePage = (HomePage_esExports);
// CONCATENATED MODULE: ./src/components/HomePage.vue
function HomePage_injectStyle (ssrContext) {
  __webpack_require__("Rw5h")
}
var HomePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HomePage___vue_template_functional__ = false
/* styles */
var HomePage___vue_styles__ = HomePage_injectStyle
/* scopeId */
var HomePage___vue_scopeId__ = "data-v-e880f27a"
/* moduleIdentifier (server only) */
var HomePage___vue_module_identifier__ = null
var HomePage_Component = HomePage_normalizeComponent(
  HomePage,
  components_HomePage,
  HomePage___vue_template_functional__,
  HomePage___vue_styles__,
  HomePage___vue_scopeId__,
  HomePage___vue_module_identifier__
)

/* harmony default export */ var src_components_HomePage = (HomePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/partials/BreadCrumpPartial.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BreadCrumpPartial = ({
  name: 'HeaderPartial',
  props: ['header'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20c6ba58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/BreadCrumpPartial.vue
var BreadCrumpPartial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.header)}}),_vm._v(" "),_c('v-divider',{staticClass:"mb-4"})],1)],1)}
var BreadCrumpPartial_staticRenderFns = []
var BreadCrumpPartial_esExports = { render: BreadCrumpPartial_render, staticRenderFns: BreadCrumpPartial_staticRenderFns }
/* harmony default export */ var partials_BreadCrumpPartial = (BreadCrumpPartial_esExports);
// CONCATENATED MODULE: ./src/components/partials/BreadCrumpPartial.vue
function BreadCrumpPartial_injectStyle (ssrContext) {
  __webpack_require__("2N6V")
}
var BreadCrumpPartial_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BreadCrumpPartial___vue_template_functional__ = false
/* styles */
var BreadCrumpPartial___vue_styles__ = BreadCrumpPartial_injectStyle
/* scopeId */
var BreadCrumpPartial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BreadCrumpPartial___vue_module_identifier__ = null
var BreadCrumpPartial_Component = BreadCrumpPartial_normalizeComponent(
  BreadCrumpPartial,
  partials_BreadCrumpPartial,
  BreadCrumpPartial___vue_template_functional__,
  BreadCrumpPartial___vue_styles__,
  BreadCrumpPartial___vue_scopeId__,
  BreadCrumpPartial___vue_module_identifier__
)

/* harmony default export */ var components_partials_BreadCrumpPartial = (BreadCrumpPartial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/AccordionWidget.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AccordionWidget = ({
  name: 'AccordionWidget',
  props: ['panels'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1386fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/AccordionWidget.vue
var AccordionWidget_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"pb-2"},[_vm._t("default")],2),_vm._v(" "),_c('v-layout',[_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((_vm.panels),function(item,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"pr-4",attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))]),_vm._v(_vm._s(item.title))],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(item.text))])],1)],1)}))],1)],1)}
var AccordionWidget_staticRenderFns = []
var AccordionWidget_esExports = { render: AccordionWidget_render, staticRenderFns: AccordionWidget_staticRenderFns }
/* harmony default export */ var widgets_AccordionWidget = (AccordionWidget_esExports);
// CONCATENATED MODULE: ./src/components/widgets/AccordionWidget.vue
function AccordionWidget_injectStyle (ssrContext) {
  __webpack_require__("drmA")
}
var AccordionWidget_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AccordionWidget___vue_template_functional__ = false
/* styles */
var AccordionWidget___vue_styles__ = AccordionWidget_injectStyle
/* scopeId */
var AccordionWidget___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccordionWidget___vue_module_identifier__ = null
var AccordionWidget_Component = AccordionWidget_normalizeComponent(
  AccordionWidget,
  widgets_AccordionWidget,
  AccordionWidget___vue_template_functional__,
  AccordionWidget___vue_styles__,
  AccordionWidget___vue_scopeId__,
  AccordionWidget___vue_module_identifier__
)

/* harmony default export */ var components_widgets_AccordionWidget = (AccordionWidget_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/ContactWidget.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ContactWidget = ({
  name: 'ContactWidget',
  data: function data() {
    return {
      dialog: false,
      postBody: {
        company: '',
        name: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },

  methods: {
    sendMessage: function sendMessage() {
      this.dialog = false;

      axios_default.a.post('https://api.smolin-budgetplan.com/api/message/contact', this.postBody).then(function (response) {
        // JSON responses are automatically parsed.
        //this.posts = response.data
        console.log("axios response", response);
      }).catch(function (e) {
        console.log("axios error:", e);
        //this.errors.push(e)
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-296a7b6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ContactWidget.vue
var ContactWidget_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"400px","margin":"auto"},attrs:{"id":"contact-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-card',[_c('v-card-media',{attrs:{"src":"/static/images/shared/boot-1992136_640.jpg"}}),_vm._v(" "),_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("Kontakt")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',[_vm._v("email")]),_vm._v(" "),_c('span',[_vm._v("info@smolin-budgetplan.com")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',[_vm._v("call")]),_vm._v(" "),_c('span',[_vm._v("+49(0)30 756 523 31")])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"blue-grey darken-2","block":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=true}}},[_vm._v("Anfrage stellen »")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Anfrage stellen:")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Firma"},model:{value:(_vm.postBody.company),callback:function ($$v) {_vm.$set(_vm.postBody, "company", $$v)},expression:"postBody.company"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Name","required":"","hint":"Ihr Name"},model:{value:(_vm.postBody.name),callback:function ($$v) {_vm.$set(_vm.postBody, "name", $$v)},expression:"postBody.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Email","required":""},model:{value:(_vm.postBody.email),callback:function ($$v) {_vm.$set(_vm.postBody, "email", $$v)},expression:"postBody.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Telefon"},model:{value:(_vm.postBody.phone),callback:function ($$v) {_vm.$set(_vm.postBody, "phone", $$v)},expression:"postBody.phone"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Ihre Anfrage","required":"","textarea":"","rules":[function (v){ return v.length <=280 || 'Max. 280 Zeichen'; }],"counter":100},model:{value:(_vm.postBody.message),callback:function ($$v) {_vm.$set(_vm.postBody, "message", $$v)},expression:"postBody.message"}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*diese Angaben sind erforderlich")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"privacy"}},[_vm._v("Datenschutzerklärung")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Schliessen")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.sendMessage()}}},[_vm._v("Absenden")])],1)],1)],1)],1)],1)}
var ContactWidget_staticRenderFns = []
var ContactWidget_esExports = { render: ContactWidget_render, staticRenderFns: ContactWidget_staticRenderFns }
/* harmony default export */ var widgets_ContactWidget = (ContactWidget_esExports);
// CONCATENATED MODULE: ./src/components/widgets/ContactWidget.vue
function ContactWidget_injectStyle (ssrContext) {
  __webpack_require__("sJil")
}
var ContactWidget_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContactWidget___vue_template_functional__ = false
/* styles */
var ContactWidget___vue_styles__ = ContactWidget_injectStyle
/* scopeId */
var ContactWidget___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContactWidget___vue_module_identifier__ = null
var ContactWidget_Component = ContactWidget_normalizeComponent(
  ContactWidget,
  widgets_ContactWidget,
  ContactWidget___vue_template_functional__,
  ContactWidget___vue_styles__,
  ContactWidget___vue_scopeId__,
  ContactWidget___vue_module_identifier__
)

/* harmony default export */ var components_widgets_ContactWidget = (ContactWidget_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CompanyPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var CompanyPage = ({
  name: 'CaompanyPage',
  components: {
    BreadCrumpPartial: components_partials_BreadCrumpPartial,
    Accordion: components_widgets_AccordionWidget,
    ContactWidget: components_widgets_ContactWidget
  },
  data: function data() {
    return {
      panelItems: [{
        icon: 'local_offer',
        color: 'blue',
        title: 'Individuelle Softwareentwicklung',
        text: 'Für viele Unternehmen ist eine maßgeschneiderte Softwareentwicklung die beste Option. Statt mehrerer suboptimaler Lösungen und ihrer unüberschaubaren Folgekosten schaffen Sie so exakt die Software an, die Sie und Ihre Mitarbeiter brauchen.'
      }, {
        icon: 'local_offer',
        color: 'blue',
        title: 'Angepasste Standardsoftware',
        text: ' Bewährte Standardlösungen für Text- oder Tabellenbearbeitung werden zwar in vielen Betrieben eingesetzt, dennoch werden meist nur ca. 5% der verfügbaren Funktionen sinnvoll eingesetzt. Durch relativ kleine Anpassungen an Workflows und Vorlagen lässt sich die Produktivität in diesem Bereich nachhaltig steigern.'
      }, {
        icon: 'local_offer',
        color: 'blue',
        title: 'Mobile Anwendungen &amp; Applikationen',
        text: 'Die Ausweitung der Funktionalitäten auf mobiler Geräte und Tablets stellen eine einschneidende Innovation in der Informationstechnologie dar. Mobilität bedeutet Zugriff auf Informationen zu jeder Zeit und von überall. Sie verschafft Kunden, Partnern und Lieferanten Flexibilität bei der Zusammenarbeit.'
      }, {
        icon: 'local_offer',
        color: 'green',
        title: 'Beratung und Integration',
        text: 'Individuell, umfassend und kompotent unterstützen wir Sie bei der Konzeption, Umsetzung und Betreueung ihrer Projekte. Unsere IT-Beratung umfasst Strategieentwicklung, Anforderungsanalyse und Konzepterstellung.'
      }, {
        icon: 'local_offer',
        color: 'yellow accent-4',
        title: 'Kundenservice',
        text: 'Für eine optimale Nutzung unser Lösungen bieten wir auch Schulungen an, die es den Anwendern ermöglichen alle Funktionen effizient einzusetzen. Neben den Schulungen sind auch Workshops zur Auffrischung der Kenntnisse Bestandteil unseres Leistungsangebotes.'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5046f45a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanyPage.vue
var CompanyPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CompanyPage"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('bread-crump-partial',{attrs:{"header":"Über Uns"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('div',[_c('p',[_c('strong',[_vm._v("\n              Die im Jahre 2013 gegründete Smolin BudgetPlan Gmbh ist ein Software- und Dienstleistungsunternehmen mit Sitz in Berlin.\n              Wir sind spezialisiert auf Planungs- und Controllingsoftware, die Entwicklung moderner Anwendungen im Internet,\n              auf dem Desktop und für mobile Endgeräte, sowie Big Data Cloud-Lösungen.\n            ")])]),_vm._v(" "),_c('p',[_vm._v("\n            Kundenorientierte Lösungen stehen bei uns an erster Stelle. So komplex IT-Dienstleistungen auch sind, wir gestalten sie nachvollziehbar\n            und in enger Abstimmung mit unseren Kunden. In Deutsch statt in Fachchinesich, mit Wissentransfer statt geheimniskrämerei,\n            denn ohne gegenseitiges Verstehen ist Zufriedenheit kaum zu erreichen.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Damit Sie Ihre Ziele erreichen, übernehmen wir für Sie von der Beratung und Konzeption über die Entwicklung bis zur Betreuung\n            der Anwendungen im Rechenzentrum oder in der Cloud alle Aufgaben. Ganz nach Ihrem Bedarf. Wir finden immer\n            die optimalste Lösung für Sie und gewährleisten auch nachdem ein Projekt erfolgreich umgesetzt wurde, unseren\n            zuverlässigen Service.\n          ")]),_vm._v(" "),_c('accordion',{attrs:{"panels":_vm.panelItems}},[_vm._v("Leistungen der Smolin BudgetPlan GmbH:")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('contact-widget')],1)],1)],1)],1)}
var CompanyPage_staticRenderFns = []
var CompanyPage_esExports = { render: CompanyPage_render, staticRenderFns: CompanyPage_staticRenderFns }
/* harmony default export */ var components_CompanyPage = (CompanyPage_esExports);
// CONCATENATED MODULE: ./src/components/CompanyPage.vue
function CompanyPage_injectStyle (ssrContext) {
  __webpack_require__("XvMX")
}
var CompanyPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CompanyPage___vue_template_functional__ = false
/* styles */
var CompanyPage___vue_styles__ = CompanyPage_injectStyle
/* scopeId */
var CompanyPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CompanyPage___vue_module_identifier__ = null
var CompanyPage_Component = CompanyPage_normalizeComponent(
  CompanyPage,
  components_CompanyPage,
  CompanyPage___vue_template_functional__,
  CompanyPage___vue_styles__,
  CompanyPage___vue_scopeId__,
  CompanyPage___vue_module_identifier__
)

/* harmony default export */ var src_components_CompanyPage = (CompanyPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SolutionsPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var SolutionsPage = ({
  name: 'SolutionsPage',
  components: {
    BreadCrumpPartial: components_partials_BreadCrumpPartial,
    Accordion: components_widgets_AccordionWidget,
    ContactWidget: components_widgets_ContactWidget
  },
  data: function data() {
    return {
      name: 'CompanyPage',
      panelItems: [{
        icon: 'local_offer',
        color: 'blue',
        title: 'Webbasierte Anwendungen',
        text: 'AngularJS, Angular, Vue, ASP.NET, PHP, HTML5, Javascript Frameworks, Apps, Websites, Services.'
      }, {
        icon: 'local_offer',
        color: 'blue',
        title: 'Desktop Applikationen',
        text: 'C#, .NET, WinRT, SQL, NoSQL, WCF Data Services, Electron.'
      }, {
        icon: 'local_offer',
        color: 'blue',
        title: 'Datenintegration',
        text: 'Schnittstellenprogrammierung, Datenkonvertierung, Testmanagment, Officeintegration.'
      }, {
        icon: 'local_offer',
        color: 'green',
        title: 'Datenpräsentation',
        text: 'Reportsysteme und Prozessmanagment.'
      }, {
        icon: 'local_offer',
        color: 'yellow accent-4',
        title: 'Datensicherheit',
        text: 'Backup, Logging, Authentifizierung, Authorisierung, Verschlüsselung.'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d16e813a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SolutionsPage.vue
var SolutionsPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('bread-crump-partial',{attrs:{"header":"Softwarelösungen"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('p',[_c('strong',[_vm._v("\r\n                Ob individuelle Software oder angepasste Standardware,  wir bieten erfolgreiche Konzepte und effiziente Umsetzung mit modernsten Techniken.\r\n            ")])]),_vm._v(" "),_c('p',[_vm._v("\r\n            Für viele Unternehmen ist eine maßgeschneiderte Softwareentwicklung die beste Option. Statt mehrerer suboptimaler Lösungen und ihrer unüberschaubaren Folgekosten\r\n            schaffen Sie so exakt die Software an, die Sie und Ihre Mitarbeiter brauchen.\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("\r\n            Um dies zu gewährleisten, arbeiten wir im Sinne der Agilen Softwareentwicklung eng mit Ihnen zusammen und entwickeln so gemeinsam die beste Lösung für Ihr Unternehmen.\r\n            Ganz nach Ihrem Bedarf, begleiten wir Sie von der Beratung und Konzeption, über die Entwciklung, bis hin zur Installation und Support bei allen Aufgaben.\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("Für ein individuelles Beratungsgespräch stehen wir Ihnen gerne zur Verfügung. "),_c('strong',[_vm._v("Sprechen Sie uns an !")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('accordion',{attrs:{"panels":_vm.panelItems}},[_vm._v("Leistungsfelder:")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('contact-widget')],1)],1)],1)}
var SolutionsPage_staticRenderFns = []
var SolutionsPage_esExports = { render: SolutionsPage_render, staticRenderFns: SolutionsPage_staticRenderFns }
/* harmony default export */ var components_SolutionsPage = (SolutionsPage_esExports);
// CONCATENATED MODULE: ./src/components/SolutionsPage.vue
function SolutionsPage_injectStyle (ssrContext) {
  __webpack_require__("r2C7")
}
var SolutionsPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SolutionsPage___vue_template_functional__ = false
/* styles */
var SolutionsPage___vue_styles__ = SolutionsPage_injectStyle
/* scopeId */
var SolutionsPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SolutionsPage___vue_module_identifier__ = null
var SolutionsPage_Component = SolutionsPage_normalizeComponent(
  SolutionsPage,
  components_SolutionsPage,
  SolutionsPage___vue_template_functional__,
  SolutionsPage___vue_styles__,
  SolutionsPage___vue_scopeId__,
  SolutionsPage___vue_module_identifier__
)

/* harmony default export */ var src_components_SolutionsPage = (SolutionsPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConsultingPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ConsultingPage = ({
  name: 'SolutionsPage',
  components: {
    BreadCrumpPartial: components_partials_BreadCrumpPartial,
    Accordion: components_widgets_AccordionWidget,
    ContactWidget: components_widgets_ContactWidget
  },
  data: function data() {
    return {
      name: 'ConsultingPage',
      panelTechItems: [{
        icon: 'local_offer',
        color: 'green',
        title: 'Userinterface (Useability)',
        text: 'Wir legen grossen Wert auf die unbedingte Benutzerfreundlichkeit und der damit verbunden Ergonomie unserer Softwareprodukte. Ziel ist es möglichst jedem User eine 100%ige Nutzung der angebotenen Funktionen zu ermöglichen.'
      }, {
        icon: 'local_offer',
        color: 'green',
        title: 'Backend (Datenbank, Cloud)',
        text: 'Das eingentliche Herzstück jeder nachhaltinger Softwarelösung. Wobei hier weniger die technische Ausführung als die Richtige sprich zu der Kondenanforderung passende Architektur ausgewählt wird.'
      }, {
        icon: 'local_offer',
        color: 'green',
        title: 'Server (Netzwerk, Skalierbarkeit)',
        text: 'Spielt eigentlich nur noch bei Inhouse-Hosting eine grosse Rolle. Bei Cloudhosting ist die Skalierbeit und Vernnetzung als Teil der Lösung schon vorhanden.'
      }, {
        icon: 'local_offer',
        color: 'green',
        title: 'Monitoring',
        text: 'Gerade bei verteilten Lösungen ist ein detailiertes Monitoring und Loggin für einen sicheren Betrieb der Soft- und Hardware unabdingbar.'
      }],
      panelPlanItems: [{
        icon: 'local_offer',
        color: 'green',
        title: 'Konzept',
        text: 'Als Projektvorbereitung wird zunächst eine Systemanalyse durchgeführt, wo zusammen mit dem Kunden die inhaltliche Erfassung der Anforderungen erfolgt. Nach der Untersuchung weiterer sachlicher und technischen Anforderungen und Randbedingen wie Schnittellen entsteht dann als Ergebniss ein Fachkonzept.'
      }, {
        icon: 'local_offer',
        color: 'green',
        title: 'Workflow',
        text: 'Die genaue Definition und Bescheibung der praktizierten Workflows hat aus unser Erfahrung eine entscheiden Einfluss auf die Umsetzungeschwindigkeit der geplanten Projekte.'
      }, {
        icon: 'local_offer',
        color: 'green',
        title: 'Projektierung',
        text: 'Selbst bei kleinenren Projekten setzen wir durchgehend auf den Einsatz von agilen Projektmanagmentprozessen. Diese haben sich auf beiden Seiten vielfach bewährt.'
      }, {
        icon: 'local_offer',
        color: 'green',
        title: 'Dokumentation',
        text: 'Eine gute und ausfühliche (technische) Dokumentation gehört zu unseren Minimumstandards bei der Entwicklung von Softwareprojekten.'
      }, {
        icon: 'local_offer',
        color: 'green',
        title: 'Datensicherheit',
        text: 'Die Berücksichtung von von Datensicherheitsrelaventen Aspketen gleich zur Anfang der Projektentwicklung zählt ebenfalls zu unseren Standards.'
      }]

    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1944a92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConsultingPage.vue
var ConsultingPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('bread-crump-partial',{attrs:{"header":"Software Beratung"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('p',[_c('strong',[_vm._v("\r\n                Softwareprojekte bestehen oft aus einer Vielzahl von sehr unterschiedlichen Komponenten. In unserem Bereich sind das in der Regel:\r\n            ")])]),_vm._v(" "),_c('p',[_vm._v("\r\n            Für viele Unternehmen ist eine maßgeschneiderte Softwareentwicklung die beste Option. Statt mehrerer suboptimaler Lösungen und ihrer unüberschaubaren Folgekosten\r\n            schaffen Sie so exakt die Software an, die Sie und Ihre Mitarbeiter brauchen.\r\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('accordion',{attrs:{"panels":_vm.panelTechItems}},[_vm._v("Technische Aspekte:")]),_vm._v(" "),_c('v-spacer',{staticClass:"pb-4"}),_vm._v(" "),_c('accordion',{attrs:{"panels":_vm.panelPlanItems}},[_vm._v("Planerische Aspekte:")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('contact-widget')],1)],1)],1)}
var ConsultingPage_staticRenderFns = []
var ConsultingPage_esExports = { render: ConsultingPage_render, staticRenderFns: ConsultingPage_staticRenderFns }
/* harmony default export */ var components_ConsultingPage = (ConsultingPage_esExports);
// CONCATENATED MODULE: ./src/components/ConsultingPage.vue
function ConsultingPage_injectStyle (ssrContext) {
  __webpack_require__("jzQN")
}
var ConsultingPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ConsultingPage___vue_template_functional__ = false
/* styles */
var ConsultingPage___vue_styles__ = ConsultingPage_injectStyle
/* scopeId */
var ConsultingPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ConsultingPage___vue_module_identifier__ = null
var ConsultingPage_Component = ConsultingPage_normalizeComponent(
  ConsultingPage,
  components_ConsultingPage,
  ConsultingPage___vue_template_functional__,
  ConsultingPage___vue_styles__,
  ConsultingPage___vue_scopeId__,
  ConsultingPage___vue_module_identifier__
)

/* harmony default export */ var src_components_ConsultingPage = (ConsultingPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ServicePage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ServicePage = ({
  name: 'ServicePage',
  components: {
    BreadCrumpPartial: components_partials_BreadCrumpPartial,
    Accordion: components_widgets_AccordionWidget,
    ContactWidget: components_widgets_ContactWidget
  },
  data: function data() {
    return {
      name: 'ConsultingPage',
      panelItems: [{
        icon: 'local_offer',
        color: 'yellow accent-4',
        title: 'Dokumentenmanagment',
        text: ' Datenbankgestütze Vorlagenmanagment für MS Word mit vorgegebenen Benneung und Ablage ist effektive und schnelle Kundenkorrespondez unerlässlich. Seit über 25 Jahren entwicklen wir hierfür angepasste Lösungen.  '
      }, {
        icon: 'local_offer',
        color: 'yellow accent-4',
        title: 'Reportingsysteme',
        text: 'Datenbank gestützte Reportingsysteme basierend auf Webtechnologie und MS Excel gehören zu unseren Stärken. Oft in Kombination mit modersten Auswertungstechniken wie <abbr>Bigdata</abbr> oder ElasticSearch ergeben viele neue Einsichten in die Daten ihrer Projekte. '
      }, {
        icon: 'local_offer',
        color: 'yellow accent-4',
        title: 'Server (Netzwerk, Skalierbarkeit)',
        text: 'Spielt eigentlich nur noch bei Inhouse-Hosting eine grosse Rolle. Bei Cloudhosting ist die Skalierbeit und Vernnetzung als Teil der Lösung schon vorhanden.'
      }, {
        icon: 'local_offer',
        color: 'yellow accent-4',
        title: 'Monitoring',
        text: 'Gerade bei verteilten Lösungen ist ein detailiertes Monitoring und Loggin für einen sicheren Betrieb der Soft- und Hardware unabdingbar.'
      }]

    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f3edd18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServicePage.vue
var ServicePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('bread-crump-partial',{attrs:{"header":"Service & Wartung"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('p',[_c('strong',[_vm._v("\n          Gerne betreuen wir die Projekte unserer Kunden auch über die Vertragsdauer hinaus. Hierbei stehen wir Ihnen mit Rat und Tat\n          zur Seite und geben Interessante Impulse für mögliche Weiterentwicklungen.\n        ")])]),_vm._v(" "),_c('p',[_vm._v("\n        Für eine optimale Nutzung unser Lösungen bieten wir auch Schulungen an, die es den Anwendern ermöglichen alle Funktionen\n        effizient einzusetzen. Neben den Schulungen sind auch Workshops zur Auffrischung der Kenntnisse Bestandteil unseres\n        Leistungsangebotes.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('accordion',{attrs:{"panels":_vm.panelItems}},[_vm._v("Leistungsfelder:")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('contact-widget')],1)],1)],1)}
var ServicePage_staticRenderFns = []
var ServicePage_esExports = { render: ServicePage_render, staticRenderFns: ServicePage_staticRenderFns }
/* harmony default export */ var components_ServicePage = (ServicePage_esExports);
// CONCATENATED MODULE: ./src/components/ServicePage.vue
function ServicePage_injectStyle (ssrContext) {
  __webpack_require__("Drpp")
}
var ServicePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ServicePage___vue_template_functional__ = false
/* styles */
var ServicePage___vue_styles__ = ServicePage_injectStyle
/* scopeId */
var ServicePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServicePage___vue_module_identifier__ = null
var ServicePage_Component = ServicePage_normalizeComponent(
  ServicePage,
  components_ServicePage,
  ServicePage___vue_template_functional__,
  ServicePage___vue_styles__,
  ServicePage___vue_scopeId__,
  ServicePage___vue_module_identifier__
)

/* harmony default export */ var src_components_ServicePage = (ServicePage_Component.exports);

// EXTERNAL MODULE: ./node_modules/d3/d3.js
var d3 = __webpack_require__("Za4h");
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/D3-Collision-Widget.vue
//
//
//
//


/* harmony default export */ var D3_Collision_Widget = ({
  name: 'D3CollisionWidget',
  mounted: function mounted() {
    var w = 1280 / 2;
    var h = 800 / 1.5;

    var nodes = d3["range"](200).map(function () {
      return {
        radius: Math.random() * 12 + 4
      };
    });
    // var color = d3.scale.category10()

    var force = d3["layout"].force().gravity(0.05).charge(function (d, i) {
      return i ? 0 : -2000;
    }).nodes(nodes).size([w, h]);

    var root = nodes[0];
    root.radius = 0;
    root.fixed = true;

    force.start();

    var svg = d3["select"](this.$el).append('svg:svg').attr('width', w).attr('height', h);

    svg.selectAll('circle').data(nodes.slice(1)).enter().append('svg:circle').attr('r', function (d) {
      return d.radius - 2;
    }).style('fill', function (d, i) {
      var returnColor;

      if (i % 3 === 0) {
        returnColor = '#5bc0de';
      } else if (i % 3 === 1) {
        returnColor = '5cb85c';
      } else {
        returnColor = 'eea236';
      }

      return returnColor;
    });

    force.on('tick', function (e) {
      var q = d3["geom"].quadtree(nodes);
      var i = 0;
      var n = nodes.length;

      while (++i < n) {
        q.visit(collide(nodes[i]));
      }

      svg.selectAll('circle').attr('cx', function (d) {
        return d.x;
      }).attr('cy', function (d) {
        return d.y;
      });
    });

    svg.on('mousemove', function () {
      var p1 = d3["mouse"](this);
      root.px = p1[0];
      root.py = p1[1];
      force.resume();
    });

    function collide(node) {
      var r = node.radius + 16;
      var nx1 = node.x - r;
      var nx2 = node.x + r;
      var ny1 = node.y - r;
      var ny2 = node.y + r;
      return function (quad, x1, y1, x2, y2) {
        if (quad.point && quad.point !== node) {
          var x = node.x - quad.point.x;
          var y = node.y - quad.point.y;
          var l = Math.sqrt(x * x + y * y);
          var r = node.radius + quad.point.radius;
          if (l < r) {
            l = (l - r) / l * 0.5;
            node.x -= x *= l;
            node.y -= y *= l;
            quad.point.x += x;
            quad.point.y += y;
          }
        }
        return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c736dfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/D3-Collision-Widget.vue
var D3_Collision_Widget_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var D3_Collision_Widget_staticRenderFns = []
var D3_Collision_Widget_esExports = { render: D3_Collision_Widget_render, staticRenderFns: D3_Collision_Widget_staticRenderFns }
/* harmony default export */ var widgets_D3_Collision_Widget = (D3_Collision_Widget_esExports);
// CONCATENATED MODULE: ./src/components/widgets/D3-Collision-Widget.vue
function D3_Collision_Widget_injectStyle (ssrContext) {
  __webpack_require__("hXkY")
}
var D3_Collision_Widget_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var D3_Collision_Widget___vue_template_functional__ = false
/* styles */
var D3_Collision_Widget___vue_styles__ = D3_Collision_Widget_injectStyle
/* scopeId */
var D3_Collision_Widget___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var D3_Collision_Widget___vue_module_identifier__ = null
var D3_Collision_Widget_Component = D3_Collision_Widget_normalizeComponent(
  D3_Collision_Widget,
  widgets_D3_Collision_Widget,
  D3_Collision_Widget___vue_template_functional__,
  D3_Collision_Widget___vue_styles__,
  D3_Collision_Widget___vue_scopeId__,
  D3_Collision_Widget___vue_module_identifier__
)

/* harmony default export */ var components_widgets_D3_Collision_Widget = (D3_Collision_Widget_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContactPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContactPage = ({
  name: 'ContactPage',
  components: {
    BreadCrumpPartial: components_partials_BreadCrumpPartial,
    ContactWidget: components_widgets_ContactWidget,
    D3CollisationWidget: components_widgets_D3_Collision_Widget
  },
  data: function data() {
    return {};
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-197ebf9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactPage.vue
var ContactPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ContactPage"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('bread-crump-partial',{attrs:{"header":"Kontakt"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('div',[_c('p',[_c('strong',[_vm._v("\n              Wir freuen uns auf Sie!\n            ")])]),_vm._v(" "),_c('p',[_vm._v("\n            Haben Sie Fragen oder benötigen Sie weitere Informationen? Wir freuen uns über Ihre Kontaktaufnahme. Ihre Daten werden von\n            uns vertraulich behandelt. Wir senden Ihnen gerne mehr Informationen zu oder rufen Sie auf Wunsch zurück.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('contact-widget')],1)],1)],1),_vm._v(" "),_c('v-container',[_c('v-layout',[_c('v-flex',[_c('D3CollisationWidget')],1)],1)],1)],1)}
var ContactPage_staticRenderFns = []
var ContactPage_esExports = { render: ContactPage_render, staticRenderFns: ContactPage_staticRenderFns }
/* harmony default export */ var components_ContactPage = (ContactPage_esExports);
// CONCATENATED MODULE: ./src/components/ContactPage.vue
function ContactPage_injectStyle (ssrContext) {
  __webpack_require__("ZkwB")
}
var ContactPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContactPage___vue_template_functional__ = false
/* styles */
var ContactPage___vue_styles__ = ContactPage_injectStyle
/* scopeId */
var ContactPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContactPage___vue_module_identifier__ = null
var ContactPage_Component = ContactPage_normalizeComponent(
  ContactPage,
  components_ContactPage,
  ContactPage___vue_template_functional__,
  ContactPage___vue_styles__,
  ContactPage___vue_scopeId__,
  ContactPage___vue_module_identifier__
)

/* harmony default export */ var src_components_ContactPage = (ContactPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/Signin.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Signin = ({
  name: 'SignInUser',
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])({
    error: 'error',
    loading: 'isLoading',
    loggedIn: 'loggedIn'
  })),
  watch: {
    loggedIn: function loggedIn(value) {
      if (value === true) {
        this.$router.push('/profile');
      }
    }
  },
  methods: {
    onSignIn: function onSignIn() {
      this.$store.dispatch('signInUser', {
        email: this.email,
        password: this.password
      });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
      console.log('dismissed alert');
    }
  },
  created: function created() {
    this.$store.dispatch('resetLoading');
    this.$store.dispatch('resetUser');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5e3844","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Signin.vue
var Signin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.error)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('app-alert',{attrs:{"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSignIn($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Email","id":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit"}},[_vm._v("Login")])],1)],1)],1)])],1)],1)],1)],1)],1)}
var Signin_staticRenderFns = []
var Signin_esExports = { render: Signin_render, staticRenderFns: Signin_staticRenderFns }
/* harmony default export */ var user_Signin = (Signin_esExports);
// CONCATENATED MODULE: ./src/components/user/Signin.vue
function Signin_injectStyle (ssrContext) {
  __webpack_require__("Jsud")
}
var Signin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Signin___vue_template_functional__ = false
/* styles */
var Signin___vue_styles__ = Signin_injectStyle
/* scopeId */
var Signin___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Signin___vue_module_identifier__ = null
var Signin_Component = Signin_normalizeComponent(
  Signin,
  user_Signin,
  Signin___vue_template_functional__,
  Signin___vue_styles__,
  Signin___vue_scopeId__,
  Signin___vue_module_identifier__
)

/* harmony default export */ var components_user_Signin = (Signin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/Signup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Signup = ({
  name: 'SignUpUser',
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])({
    error: 'error',
    loading: 'isLoading',
    loggedIn: 'loggedIn'
  }), {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? 'Passwörte stimmen nicht überein' : '';
    }
  }),
  watch: {
    loggedIn: function loggedIn(value) {
      if (value === true) {
        this.$router.push('/profile');
      }
    }
  },
  methods: {
    onSignup: function onSignup() {
      this.$store.dispatch('signUpUser', {
        email: this.email,
        password: this.password
      });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
      console.log('dismissed alert');
    }
  },
  created: function created() {
    this.$store.dispatch('resetLoading');
    this.$store.dispatch('resetUser');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44b822d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Signup.vue
var Signup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.error)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('app-alert',{attrs:{"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSignup($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Email","id":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"confirmPassword","label":" Confirm Password","id":"confirmPassword","type":"password","rules":[_vm.comparePasswords]},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit","disabled":!_vm.loading,"loading":!_vm.loading}},[_vm._v("\n                    Registrieren\n                    "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)])],1)],1)],1)])],1)],1)],1)],1)],1)}
var Signup_staticRenderFns = []
var Signup_esExports = { render: Signup_render, staticRenderFns: Signup_staticRenderFns }
/* harmony default export */ var user_Signup = (Signup_esExports);
// CONCATENATED MODULE: ./src/components/user/Signup.vue
function Signup_injectStyle (ssrContext) {
  __webpack_require__("GeVJ")
}
var Signup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Signup___vue_template_functional__ = false
/* styles */
var Signup___vue_styles__ = Signup_injectStyle
/* scopeId */
var Signup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Signup___vue_module_identifier__ = null
var Signup_Component = Signup_normalizeComponent(
  Signup,
  user_Signup,
  Signup___vue_template_functional__,
  Signup___vue_styles__,
  Signup___vue_scopeId__,
  Signup___vue_module_identifier__
)

/* harmony default export */ var components_user_Signup = (Signup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/ProfilePage.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var ProfilePage = ({
  name: 'ProfilePage',
  methods: {
    onLogout: function onLogout() {
      this.$store.dispatch('resetUser');
      this.$router.push('/');
    }
  },
  mounted: function mounted() {

    $("#testbtn").html('test2');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66162750","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ProfilePage.vue
var ProfilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("PROFILE PAGE")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){$event.preventDefault();_vm.onLogout()}}},[_vm._v("Logout")]),_vm._v(" "),_c('br')],1)}
var ProfilePage_staticRenderFns = []
var ProfilePage_esExports = { render: ProfilePage_render, staticRenderFns: ProfilePage_staticRenderFns }
/* harmony default export */ var user_ProfilePage = (ProfilePage_esExports);
// CONCATENATED MODULE: ./src/components/user/ProfilePage.vue
function ProfilePage_injectStyle (ssrContext) {
  __webpack_require__("AK5/")
}
var ProfilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ProfilePage___vue_template_functional__ = false
/* styles */
var ProfilePage___vue_styles__ = ProfilePage_injectStyle
/* scopeId */
var ProfilePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProfilePage___vue_module_identifier__ = null
var ProfilePage_Component = ProfilePage_normalizeComponent(
  ProfilePage,
  user_ProfilePage,
  ProfilePage___vue_template_functional__,
  ProfilePage___vue_styles__,
  ProfilePage___vue_scopeId__,
  ProfilePage___vue_module_identifier__
)

/* harmony default export */ var components_user_ProfilePage = (ProfilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LegalPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var LegalPage = ({
  name: 'LegalPage',
  components: {
    BreadCrumpPartial: components_partials_BreadCrumpPartial,
    ContactWidget: components_widgets_ContactWidget
  },
  data: function data() {
    return {
      itemsLegal: [{
        title: 'Firma:',
        paragraph: ['<b>Smolin BudgetPlan GmbH</b><br />Lichterfelder Ring 208<br />12209 Berlin<br />']
      }, {
        title: 'Gesetzlicher Vertreter:',
        paragraph: ['Herr Dr. Roland Smolin</br></br></br>']
      }, {
        title: 'Handelsregister:',
        paragraph: ['Amstgericht Charlottenburg in Berlin, HRB 155536']
      }, {
        title: 'UStIdNr gemäß §27 a Umsatzsteuergesetz:',
        paragraph: ['DE 292 833 311']
      }, {
        title: 'Kontakt:',
        paragraph: [' <table><tr><td><p>Telefon:</p></td><td><p>+49(0)30 756 523 31</p></td></tr><tr><td><p>Telefax:</p></td><td><p>+49(0)30 756 523 32</p></td></tr><tr><td><p>E-Mail:</p></td><td><p>info@smolin-budgetplan.com</p></td><tr><td><p>Internet:</p></td><td><p>www.smolin-budgetplan.com</p></td></tr></table>']
      }, {
        title: 'Quellenangaben für die verwendeten Bilder:',
        paragraph: ['<a rel="nofollow" href="http://de.fotolia.com/id/49058708">&copy; Coloures-Pic - Fotolia.com</a><br /><a rel="nofollow" href="http://de.fotolia.com/id/50990348">&copy; alphaspirit - Fotolia.com</a><br /><a rel="nofollow" href="http://de.fotolia.com/id/48664923">&copy; alphaspirit - Fotolia.com</a><br />']
      }],
      items: [{
        title: 'Rechtliche Hinweise',
        paragraph: [' <h4>Haftung für Inhalte</h4>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.', '<h4>Haftung für Links</h4>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.', '<h4>Urheberrecht</h4>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.', '<i>Quellen: Disclaimer von eRecht24, dem Portal zum Internetrecht von Rechtsanwalt Sören Siebert</i>']
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f58e447","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegalPage.vue
var LegalPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('bread-crump-partial',{attrs:{"header":"Impressum"}}),_vm._v(" "),_c('h3',{staticClass:"mb-2"},[_vm._v("Angaben gemäß § 5 Telemediengestz (TMG)")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.itemsLegal),function(legal,index){return _c('v-flex',{key:index,attrs:{"xs6":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          "+_vm._s(legal.title)+"\n          ")]),_vm._v(" "),_vm._l((legal.paragraph),function(para,index){return _c('v-card-text',{key:index,domProps:{"innerHTML":_vm._s(para)}})})],2)],1)})),_vm._v(" "),_c('v-spacer',{staticClass:"mt-5"}),_vm._v(" "),_c('h3',{staticClass:"mb-2"},[_vm._v("Rechtliche Hinweise:")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.items),function(item,index){return _c('v-flex',{key:index,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',[_c('v-card-title'),_vm._v(" "),_vm._l((item.paragraph),function(para,index){return _c('v-card-text',{key:index,domProps:{"innerHTML":_vm._s(para)}})})],2)],1)}))],1)}
var LegalPage_staticRenderFns = []
var LegalPage_esExports = { render: LegalPage_render, staticRenderFns: LegalPage_staticRenderFns }
/* harmony default export */ var components_LegalPage = (LegalPage_esExports);
// CONCATENATED MODULE: ./src/components/LegalPage.vue
function LegalPage_injectStyle (ssrContext) {
  __webpack_require__("HBB0")
}
var LegalPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LegalPage___vue_template_functional__ = false
/* styles */
var LegalPage___vue_styles__ = LegalPage_injectStyle
/* scopeId */
var LegalPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LegalPage___vue_module_identifier__ = null
var LegalPage_Component = LegalPage_normalizeComponent(
  LegalPage,
  components_LegalPage,
  LegalPage___vue_template_functional__,
  LegalPage___vue_styles__,
  LegalPage___vue_scopeId__,
  LegalPage___vue_module_identifier__
)

/* harmony default export */ var src_components_LegalPage = (LegalPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PrivacyPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var PrivacyPage = ({
  name: 'PrivacyPage',
  components: {
    BreadCrumpPartial: components_partials_BreadCrumpPartial,
    ContactWidget: components_widgets_ContactWidget
  },
  data: function data() {
    return {
      items: []
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ed457d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrivacyPage.vue
var PrivacyPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('bread-crump-partial',{attrs:{"header":"Datenschutz"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Verantwortlicher")]),_vm._v(" "),_c('p',[_vm._v("\n          Smolin-Budgetplan GmbH\n          "),_c('br'),_vm._v("Lichterfelder Ring 208\n          "),_c('br'),_vm._v("12209 Berlin, Deutschland\n          "),_c('br'),_vm._v("Handelsregister/Nr.: HRB 155536\n          "),_c('br'),_vm._v("Geschäftsführer: Dr. Roland Smolin\n          "),_c('br'),_vm._v("info@smolin-budgetplan.com\n          "),_c('br'),_vm._v("Stand: 24.04.2018\n        ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("1. GRUNDSÄTZLICHE ANGABEN ZUR DATENVERARBEITUNG UND RECHTSGRUNDLAGEN")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("1.1 Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten innerhalb unseres Onlineangebotes und der mit ihm verbundenen Webseiten, Funktionen und Inhalte (nachfolgend gemeinsam bezeichnet als „Onlineangebot“ oder „Website“) auf. Die Datenschutzerklärung gilt unabhängig von den verwendeten Domains, Systemen, Plattformen und Geräten (z.B. Desktop oder Mobile) auf denen das Onlineangebot ausgeführt wird.")]),_vm._v(" "),_c('li',[_vm._v("\n            1.2 Die verwendeten Begrifflichkeiten, wie z.B. „personenbezogene Daten“ oder deren „Verarbeitung“ verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            1.3 Zu den im Rahmen dieses Onlineangebotes verarbeiteten personenbezogenen Daten der Nutzer gehören Bestandsdaten (z.B., Namen und Adressen von Kunden), Vertragsdaten (z.B., in Anspruch genommene Leistungen, Namen von Sachbearbeitern, Zahlungsinformationen), Nutzungsdaten (z.B., die besuchten Webseiten unseres Onlineangebotes, Interesse an unseren Produkten) und Inhaltsdaten (z.B., Eingaben im Kontaktformular).\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            1.4 Der Begriff „Nutzer“ umfasst alle Kategorien von der Datenverarbeitung betroffener Personen. Zu ihnen gehören unsere Geschäftspartner, Kunden, Interessenten und sonstige Besucher unseres Onlineangebotes. Die verwendeten Begrifflichkeiten, wie z.B. „Nutzer“ sind geschlechtsneutral zu verstehen.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            1.5 Wir verarbeiten personenbezogene Daten der Nutzer nur unter Einhaltung der einschlägigen Datenschutzbestimmungen. Das bedeutet, die Daten der Nutzer werden nur bei Vorliegen einer gesetzlichen Erlaubnis verarbeitet. D.h., insbesondere wenn die Datenverarbeitung zur Erbringung unserer vertraglichen Leistungen (z.B. Bearbeitung von Aufträgen) sowie Online-Services erforderlich, bzw. gesetzlich vorgeschrieben ist, eine Einwilligung der Nutzer vorliegt, als auch aufgrund unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb und Sicherheit unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO, insbesondere bei der Reichweitenmessung, Erstellung von Profilen zu Werbe- und Marketingzwecken sowie Erhebung von Zugriffsdaten und Einsatz der Dienste von Drittanbietern.\n          ")]),_vm._v(" "),_c('li',[_vm._v("1.6 Wir weisen darauf hin, dass die Rechtsgrundlage der Einwilligungen Art. 6 Abs. 1 lit. a. und Art. 7 DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer Leistungen und Durchführung vertraglicher Maßnahmen Art. 6 Abs. 1 lit. b. DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer rechtlichen Verpflichtungen Art. 6 Abs. 1 lit. c. DSGVO, und die Rechtsgrundlage für die Verarbeitung zur Wahrung unserer berechtigten Interessen Art. 6 Abs. 1 lit. f. DSGVO ist.")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("2. SICHERHEITSMASSNAHMEN")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            2.1 Wir treffen organisatorische, vertragliche und technische Sicherheitsmaßnahmen entsprechend dem Stand der Technik, um sicherzustellen, dass die Vorschriften der Datenschutzgesetze eingehalten werden und um damit die durch uns verarbeiteten Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            2.2 Zu den Sicherheitsmaßnahmen gehört insbesondere die verschlüsselte Übertragung von Daten zwischen Ihrem Browser und unserem Server.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("3. WEITERGABE VON DATEN AN DRITTE UND DRITTANBIETER")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            3.1 Eine Weitergabe von Daten an Dritte erfolgt nur im Rahmen der gesetzlichen Vorgaben. Wir geben die Daten der Nutzer an Dritte nur dann weiter, wenn dies z.B. auf Grundlage des Art. 6 Abs. 1 lit. b) DSGVO für Vertragszwecke erforderlich ist oder auf Grundlage berechtigter Interessen gem. Art. 6 Abs. 1 lit. f. DSGVO an wirtschaftlichem und effektivem Betrieb unseres Geschäftsbetriebes.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            3.2 Sofern wir Subunternehmer einsetzen, um unsere Leistungen bereitzustellen, ergreifen wir geeignete rechtliche Vorkehrungen sowie entsprechende technische und organisatorische Maßnahmen, um für den Schutz der personenbezogenen Daten gemäß den einschlägigen gesetzlichen Vorschriften zu sorgen.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            3.3 Sofern im Rahmen dieser Datenschutzerklärung Inhalte, Werkzeuge oder sonstige Mittel von anderen Anbietern (nachfolgend gemeinsam bezeichnet als „Drittanbieter“) eingesetzt werden und deren genannter Sitz sich in einem Drittland befindet, ist davon auszugehen, dass ein Datentransfer in die Sitzstaaten der Drittanbieter stattfindet. Als Drittstaaten sind Länder zu verstehen, in denen die DSGVO kein unmittelbar geltendes Recht ist, d.h. grundsätzlich Länder außerhalb der EU, bzw. des Europäischen Wirtschaftsraums. Die Übermittlung von Daten in Drittstaaten erfolgt entweder, wenn ein angemessenes Datenschutzniveau, eine Einwilligung der Nutzer oder sonst eine gesetzliche Erlaubnis vorliegt.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("4. ERBRINGUNG VERTRAGLICHER LEISTUNGEN")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            4.1 Wir verarbeiten Bestandsdaten (z.B., Namen und Adressen sowie Kontaktdaten von Nutzern), Vertragsdaten (z.B., in Anspruch genommene Leistungen, Namen von Kontaktpersonen, Zahlungsinformationen) zwecks Erfüllung unserer vertraglichen Verpflichtungen und Serviceleistungen gem. Art. 6 Abs. 1 lit b. DSGVO.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("5. KONTAKTAUFNAHME")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            5.1 Bei der Kontaktaufnahme mit uns (per Kontaktformular oder E-Mail) werden die Angaben des Nutzers zur Bearbeitung der Kontaktanfrage und deren Abwicklung gem. Art. 6 Abs. 1 lit. b) DSGVO verarbeitet.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            5.2 Die Angaben der Nutzer können in unserem Customer-Relationship-Management System („CRM System“) oder vergleichbarer Anfragenorganisation gespeichert werden.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("6. KOMMENTARE UND BEITRÄGE")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            6.1 Wenn Nutzer Kommentare oder sonstige Beiträge hinterlassen, werden ihre IP-Adressen auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO für 7 Tage gespeichert.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            6.2 Das erfolgt zu unserer Sicherheit, falls jemand in Kommentaren und Beiträgen widerrechtliche Inhalte hinterlässt (Beleidigungen, verbotene politische Propaganda, etc.). In diesem Fall können wir selbst für den Kommentar oder Beitrag belangt werden und sind daher an der Identität des Verfassers interessiert.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("7. ERHEBUNG VON ZUGRIFFSDATEN UND LOGFILES")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            7.1 Wir erheben auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO Daten über jeden Zugriff auf den Server, auf dem sich dieser Dienst befindet (sogenannte Serverlogfiles). Zu den Zugriffsdaten gehören Name der abgerufenen Webseite, Datei, Datum und Uhrzeit des Abrufs, übertragene Datenmenge, Meldung über erfolgreichen Abruf, Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite), IP-Adresse und der anfragende Provider.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            7.2 Logfile-Informationen werden aus Sicherheitsgründen (z.B. zur Aufklärung von Missbrauchs- oder Betrugshandlungen) für die Dauer von maximal sieben Tagen gespeichert und danach gelöscht. Daten, deren weitere Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur endgültigen Klärung des jeweiligen Vorfalls von der Löschung ausgenommen.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("8. COOKIES & REICHWEITENMESSUNG")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            8.1 Cookies sind Informationen, die von unserem Webserver oder Webservern Dritter an die Web-Browser der Nutzer übertragen und dort für einen späteren Abruf gespeichert werden.Bei Cookies kann es sich um kleine Dateien oder sonstige Arten der Informationsspeicherung handeln.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            8.2 Über den Einsatz von Cookies im Rahmen pseudonymer Reichweitenmessung werden die Nutzer im Rahmen dieser Datenschutzerklärung informiert.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            8.3 Falls die Nutzer nicht möchten, dass Cookies auf ihrem Rechner gespeichert werden, werden sie gebeten die entsprechende Option in den Systemeinstellungen ihres Browsers zu deaktivieren. Gespeicherte Cookies können in den Systemeinstellungen des Browsers gelöscht werden. Der Ausschluss von Cookies kann zu Funktionseinschränkungen dieses Onlineangebotes führen.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            8.4 Sie können dem Einsatz von Cookies, die der Reichweitenmessung und Werbezwecken dienen, über die Deaktivierungsseite der Netzwerkwerbeinitiative "),_c('a',{attrs:{"href":"http://optout.networkadvertising.org/"}},[_vm._v("(http://optout.networkadvertising.org/)")]),_vm._v(" und zusätzlich die US-amerikanische Webseite "),_c('a',{attrs:{"href":"http://www.aboutads.info/choices"}},[_vm._v("(http://www.aboutads.info/choices)")]),_vm._v(" oder die europäische Webseite "),_c('a',{attrs:{"href":"http://www.youronlinechoices.com/uk/your-ad-choices/"}},[_vm._v("(http://www.youronlinechoices.com/uk/your-ad-choices/)")]),_vm._v(" widersprechen.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("9. GOOGLE ANALYTICS")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            9.1 Wir setzen auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Google Analytics, einen Webanalysedienst der Google Inc. („Google“) ein. Google verwendet Cookies. Die durch das Cookie erzeugten Informationen über Benutzung des Onlineangebotes durch die Nutzer werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.")]),_vm._v(" "),_c('li',[_vm._v("\n            9.2 Google ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europäische Datenschutzrecht einzuhalten "),_c('a',{attrs:{"href":"https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active"}},[_vm._v("(https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active)")]),_vm._v(".\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            9.3 Google wird diese Informationen in unserem Auftrag benutzen, um die Nutzung unseres Onlineangebotes durch die Nutzer auszuwerten, um Reports über die Aktivitäten innerhalb dieses Onlineangebotes zusammenzustellen und um weitere, mit der Nutzung dieses Onlineangebotes und der Internetnutzung verbundene Dienstleistungen, uns gegenüber zu erbringen. Dabei können aus den verarbeiteten Daten pseudonyme Nutzungsprofile der Nutzer erstellt werden.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            9.4 Wir setzen Google Analytics ein, um die durch innerhalb von Werbediensten Googles und seiner Partner geschalteten Anzeigen, nur solchen Nutzern anzuzeigen, die auch ein Interesse an unserem Onlineangebot gezeigt haben oder die bestimmte Merkmale (z.B. Interessen an bestimmten Themen oder Produkten, die anhand der besuchten Webseiten bestimmt werden) aufweisen, die wir an Google übermitteln (sog. „Remarketing-“, bzw. „Google-Analytics-Audiences“). Mit Hilfe der Remarketing Audiences möchten wir auch sicherstellen, dass unsere Anzeigen dem potentiellen Interesse der Nutzer entsprechen und nicht belästigend wirken.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            9.5 Wir setzen Google Analytics nur mit aktivierter IP-Anonymisierung ein. Das bedeutet, die IP-Adresse der Nutzer wird von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            9.6 Die von dem Browser des Nutzers übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Die Nutzer können die Speicherung der Cookies durch eine entsprechende Einstellung ihrer Browser-Software verhindern; die Nutzer können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf ihre Nutzung des Onlineangebotes bezogenen Daten an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter folgendem Link verfügbare Browser-Plugin herunterladen und installieren: "),_c('a',{attrs:{"href":"http://tools.google.com/dlpage/gaoptout?hl=de"}},[_vm._v("http://tools.google.com/dlpage/gaoptout?hl=de")]),_vm._v(".\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            9.7 Weitere Informationen zur Datennutzung durch Google, Einstellungs- und Widerspruchsmöglichkeiten erfahren Sie auf den Webseiten von Google: "),_c('a',{attrs:{"href":"https://www.google.com/intl/de/policies/privacy/partners"}},[_vm._v("https://www.google.com/intl/de/policies/privacy/partners")]),_vm._v(" („Datennutzung durch Google bei Ihrer Nutzung von Websites oder Apps unserer Partner“), "),_c('a',{attrs:{"href":"http://www.google.com/policies/technologies/ads"}},[_vm._v("http://www.google.com/policies/technologies/ads")]),_vm._v(" („Datennutzung zu Werbezwecken“), "),_c('a',{attrs:{"href":""}}),_vm._v("http://www.google.de/settings/ads („Informationen verwalten, die Google verwendet, um Ihnen Werbung einzublenden“).\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("10. GOOGLE-RE/MARKETING-SERVICES")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            10.1 Wir nutzen auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) die Marketing- und Remarketing-Dienste (kurz „Google-Marketing-Services”) der Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, („Google“).\n          ")]),_vm._v(" "),_c('li',[_vm._v("10.2 Google ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europäische Datenschutzrecht einzuhalten "),_c('a',{attrs:{"href":"https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active"}},[_vm._v("(https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active)")]),_vm._v(" .")]),_vm._v(" "),_c('li',[_vm._v("\n            10.3 Die Google-Marketing-Services erlauben uns Werbeanzeigen für und auf unserer Website gezielter anzuzeigen, um Nutzern nur Anzeigen zu präsentieren, die potentiell deren Interessen entsprechen. Falls einem Nutzer z.B. Anzeigen für Produkte angezeigt werden, für die er sich auf anderen Webseiten interessiert hat, spricht man hierbei vom „Remarketing“. Zu diesen Zwecken wird bei Aufruf unserer und anderer Webseiten, auf denen Google-Marketing-Services aktiv sind, unmittelbar durch Google ein Code von Google ausgeführt und es werden sog. (Re)marketing-Tags (unsichtbare Grafiken oder Code, auch als „Web Beacons“ bezeichnet) in die Webseite eingebunden. Mit deren Hilfe wird auf dem Gerät der Nutzer ein individuelles Cookie, d.h. eine kleine Datei abgespeichert (statt Cookies können auch vergleichbare Technologien verwendet werden). Die Cookies können von verschiedenen Domains gesetzt werden, unter anderem von google.com, doubleclick.net, invitemedia.com, admeld.com, googlesyndication.com oder googleadservices.com. In dieser Datei wird vermerkt, welche Webseiten der Nutzer aufgesucht, für welche Inhalte er sich interessiert und welche Angebote er geklickt hat, ferner technische Informationen zum Browser und Betriebssystem, verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung des Onlineangebotes. Es wird ebenfalls die IP-Adresse der Nutzer erfasst, wobei wir im Rahmen von Google-Analytics mitteilen, dass die IP-Adresse innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum gekürzt und nur in Ausnahmefällen ganz an einen Server von Google in den USA übertragen und dort gekürzt wird. Die IP-Adresse wird nicht mit Daten des Nutzers innerhalb von anderen Angeboten von Google zusammengeführt. Die vorstehend genannten Informationen können seitens Google auch mit solchen Informationen aus anderen Quellen verbunden werden. Wenn der Nutzer anschließend andere Webseiten besucht, können ihm entsprechend seiner Interessen die auf ihn abgestimmten Anzeigen angezeigt werden.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            10.4 Die Daten der Nutzer werden im Rahmen der Google-Marketing-Services pseudonym verarbeitet. D.h. Google speichert und verarbeitet z.B. nicht den Namen oder E-Mailadresse der Nutzer, sondern verarbeitet die relevanten Daten Cookie-bezogen innerhalb pseudonymer Nutzer-Profile. D.h. aus der Sicht von Google werden die Anzeigen nicht für eine konkret identifizierte Person verwaltet und angezeigt, sondern für den Cookie-Inhaber, unabhängig davon wer dieser Cookie-Inhaber ist. Dies gilt nicht, wenn ein Nutzer Google ausdrücklich erlaubt hat, die Daten ohne diese Pseudonymisierung zu verarbeiten. Die von Google-Marketing-Services über die Nutzer gesammelten Informationen werden an Google übermittelt und auf Googles Servern in den USA gespeichert.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            10.5 Weitere Informationen zur Datennutzung zu Marketingzwecken durch Google, erfahren Sie auf der Übersichtsseite: "),_c('a',{attrs:{"href":"https://www.google.com/policies/technologies/ads"}},[_vm._v("https://www.google.com/policies/technologies/ads")]),_vm._v("https://www.google.com/policies/privacy"),_vm._v(" abrufbar.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            10.6 Wenn Sie der interessensbezogenen Werbung durch Google-Marketing-Services widersprechen möchten, können Sie die von Google gestellten Einstellungs- und Opt-Out-Möglichkeiten nutzen: "),_c('a',{attrs:{"href":"http://www.google.com/ads/preferences"}},[_vm._v("http://www.google.com/ads/preferences")]),_vm._v(".\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("11. EINBINDUNG VON DIENSTEN UND INHALTEN DRITTER")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            11.1 Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von Drittanbietern ein, um deren Inhalte und Services, wie z.B. Videos oder Schriftarten einzubinden (nachfolgend einheitlich bezeichnet als “Inhalte”). Dies setzt immer voraus, dass die Drittanbieter dieser Inhalte, die IP-Adresse der Nutzer wahrnehmen, da sie ohne die IP-Adresse die Inhalte nicht an deren Browser senden könnten. Die IP-Adresse ist damit für die Darstellung dieser Inhalte erforderlich. Wir bemühen uns nur solche Inhalte zu verwenden, deren jeweilige Anbieter die IP-Adresse lediglich zur Auslieferung der Inhalte verwenden. Drittanbieter können ferner so genannte Pixel-Tags (unsichtbare Grafiken, auch als „Web Beacons“ bezeichnet) für statistische oder Marketingzwecke verwenden. Durch die „Pixel-Tags“ können Informationen, wie der Besucherverkehr auf den Seiten dieser Website ausgewertet werden. Die pseudonymen Informationen können ferner in Cookies auf dem Gerät der Nutzer gespeichert werden und unter anderem technische Informationen zum Browser und Betriebssystem, verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung unseres Onlineangebotes enthalten, als auch mit solchen Informationen aus anderen Quellen verbunden werden können.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            11.2 Die nachfolgende Darstellung bietet eine Übersicht von Drittanbietern sowie ihrer Inhalte, nebst Links zu deren Datenschutzerklärungen, welche weitere Hinweise zur Verarbeitung von Daten und, z.T. bereits hier genannt, Widerspruchsmöglichkeiten (sog. Opt-Out) enthalten:"),_c('br'),_vm._v("\n            – Externe Schriftarten von Google, Inc., "),_c('a',{attrs:{"href":"https://www.google.com/fonts"}},[_vm._v("https://www.google.com/fonts")]),_vm._v(" („Google Fonts“). Die Einbindung der Google Fonts erfolgt durch einen Serveraufruf bei Google (in der Regel in den USA). Datenschutzerklärung: "),_c('a',{attrs:{"href":"https://www.google.com/policies/privacy/"}},[_vm._v("https://www.google.com/policies/privacy/")]),_vm._v(", Opt-Out: "),_c('a',{attrs:{"href":"https://www.google.com/settings/ads/"}},[_vm._v("https://www.google.com/settings/ads/")]),_vm._v("."),_c('br'),_vm._v("\n            – Externer Code des JavaScript-Frameworks “jQuery”, bereitgestellt durch den Dritt-Anbieter jQuery Foundation, "),_c('a',{attrs:{"href":"https://jquery.org"}},[_vm._v("https://jquery.org")]),_vm._v("."),_c('br')])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("12. RECHTE DER NUTZER")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            12.1 Nutzer haben das Recht, auf Antrag unentgeltlich Auskunft zu erhalten über die personenbezogenen Daten, die von uns über sie gespeichert wurden.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            12.2 Zusätzlich haben die Nutzer das Recht auf Berichtigung unrichtiger Daten, Einschränkung der Verarbeitung und Löschung ihrer personenbezogenen Daten, sofern zutreffend, Ihre Rechte auf Datenportabilität geltend zu machen und im Fall der Annahme einer unrechtmäßigen Datenverarbeitung, eine Beschwerde bei der zuständigen Aufsichtsbehörde einzureichen.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            12.3 Ebenso können Nutzer Einwilligungen, grundsätzlich mit Auswirkung für die Zukunft, widerrufen.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("13. LÖSCHUNG VON DATEN")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            13.1 Die bei uns gespeicherten Daten werden gelöscht, sobald sie für ihre Zweckbestimmung nicht mehr erforderlich sind und der Löschung keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten der Nutzer nicht gelöscht werden, weil sie für andere und gesetzlich zulässige Zwecke erforderlich sind, wird deren Verarbeitung eingeschränkt. D.h. die Daten werden gesperrt und nicht für andere Zwecke verarbeitet. Das gilt z.B. für Daten der Nutzer, die aus handels- oder steuerrechtlichen Gründen aufbewahrt werden müssen.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            13.2 Nach gesetzlichen Vorgaben erfolgt die Aufbewahrung für 6 Jahre gemäß § 257 Abs. 1 HGB (Handelsbücher, Inventare, Eröffnungsbilanzen, Jahresabschlüsse, Handelsbriefe, Buchungsbelege, etc.) sowie für 10 Jahre gemäß § 147 Abs. 1 AO (Bücher, Aufzeichnungen, Lageberichte, Buchungsbelege, Handels- und Geschäftsbriefe, Für Besteuerung relevante Unterlagen, etc.).\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("14. WIDERSPRUCHSRECHT")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            14.1 Nutzer können der künftigen Verarbeitung ihrer personenbezogenen Daten entsprechend den gesetzlichen Vorgaben jederzeit widersprechen. Der Widerspruch kann insbesondere gegen die Verarbeitung für Zwecke der Direktwerbung erfolgen.\n          ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("15. ÄNDERUNGEN DER DATENSCHUTZERKLÄRUNG")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            15.1 Wir behalten uns vor, die Datenschutzerklärung zu ändern, um sie an geänderte Rechtslagen, oder bei Änderungen des Dienstes sowie der Datenverarbeitung anzupassen. Dies gilt jedoch nur im Hinblick auf Erklärungen zur Datenverarbeitung. Sofern Einwilligungen der Nutzer erforderlich sind oder Bestandteile der Datenschutzerklärung Regelungen des Vertragsverhältnisses mit den Nutzern enthalten, erfolgen die Änderungen nur mit Zustimmung der Nutzer.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            15.2 Die Nutzer werden gebeten sich regelmäßig über den Inhalt der Datenschutzerklärung zu informieren.")])])])],1)],1)],1)}
var PrivacyPage_staticRenderFns = []
var PrivacyPage_esExports = { render: PrivacyPage_render, staticRenderFns: PrivacyPage_staticRenderFns }
/* harmony default export */ var components_PrivacyPage = (PrivacyPage_esExports);
// CONCATENATED MODULE: ./src/components/PrivacyPage.vue
function PrivacyPage_injectStyle (ssrContext) {
  __webpack_require__("ItQ7")
}
var PrivacyPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrivacyPage___vue_template_functional__ = false
/* styles */
var PrivacyPage___vue_styles__ = PrivacyPage_injectStyle
/* scopeId */
var PrivacyPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrivacyPage___vue_module_identifier__ = null
var PrivacyPage_Component = PrivacyPage_normalizeComponent(
  PrivacyPage,
  components_PrivacyPage,
  PrivacyPage___vue_template_functional__,
  PrivacyPage___vue_styles__,
  PrivacyPage___vue_scopeId__,
  PrivacyPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PrivacyPage = (PrivacyPage_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js














vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_HomePage
  }, {
    path: '/company',
    name: 'Company',
    component: src_components_CompanyPage
  }, {
    path: '/solutions',
    name: 'Solutions',
    component: src_components_SolutionsPage
  }, {
    path: '/consulting',
    name: 'Consulting',
    component: src_components_ConsultingPage
  }, {
    path: '/service',
    name: 'Service',
    component: src_components_ServicePage
  }, {
    path: '/contact',
    name: 'Contact',
    component: src_components_ContactPage
  }, {
    path: '/signin',
    name: 'Signin',
    component: components_user_Signin
  }, {
    path: '/signup',
    name: 'Signup',
    component: components_user_Signup
  }, {
    path: '/profile',
    name: 'Profile',
    component: components_user_ProfilePage
  }, {
    path: '/privacy',
    name: 'Privacy',
    component: src_components_PrivacyPage
  }, {
    path: '/legal',
    name: 'Legal',
    component: src_components_LegalPage
  }],
  mode: 'history'
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vuex-localstorage/dist/index.js
var dist = __webpack_require__("kQU8");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./src/store/mutation-types.js
var STORE_FETCHED_CATEGORIES = 'STORE_FETCHED_CATEGORIES';
var CATEGORIES_LOADED = 'CATEGORIES_LOADED';

var STORE_FETCHED_PAGES = 'STORE_FETCHED_PAGES';
var PAGES_LOADED = 'PAGES_LOADED';

var STORE_FETCHED_POSTS = 'STORE_FETCHED_POSTS';
var POSTS_LOADED = 'POSTS_LOADED';

var STORE_FETCHED_USER = 'STORE_FETCHED_USER';
var LOGIN_USER = 'LOGIN_USER';
var LOGOUT_USER = 'LOGOUT_USER';

var INCREMENT_LOADING_PROGRESS = 'INCREMENT_LOADING_PROGRESS';
var RESET_LOADING_PROGRESS = 'RESET_LOADING_PROGRESS';

var STORE_CLEAR_ERROR = 'STORE_CLEAR_ERROR';
var STORE_FETCHED_ERROR = 'STORE_FETCHED_ERROR';
// EXTERNAL MODULE: ./node_modules/firebase/index.js
var firebase = __webpack_require__("Sazm");
var firebase_default = /*#__PURE__*/__webpack_require__.n(firebase);

// CONCATENATED MODULE: ./src/store/actions.js

// import api from '../api'


// export const loginUser = ({ commit }) => {
//   auth.signInAnonymously().catch(function (error) {
//     // Handle Errors here.
//     return false
//   })
// }

var actions_signUpUser = function signUpUser(_ref, payload) {
  var commit = _ref.commit;

  commit(INCREMENT_LOADING_PROGRESS);
  commit(STORE_CLEAR_ERROR);

  firebase["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
    commit(RESET_LOADING_PROGRESS);
    commit(STORE_FETCHED_USER, user.uid);
    commit(LOGIN_USER);

    var newUser = {
      id: user.uid
    };
    console.log('NewUser:', newUser);
  }).catch(function (error) {
    commit(RESET_LOADING_PROGRESS);
    commit(STORE_FETCHED_ERROR, error);
    console.log(error);
  });
};

var actions_signInUser = function signInUser(_ref2, payload) {
  var commit = _ref2.commit;

  commit(INCREMENT_LOADING_PROGRESS);
  commit(STORE_CLEAR_ERROR);

  firebase["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
    commit(RESET_LOADING_PROGRESS);
    commit(STORE_FETCHED_USER, user.uid);
    commit(LOGIN_USER);

    var loginUser = {
      id: user.uid
    };
    console.log('LoginUser:', user.uid);
  }).catch(function (error) {
    commit(RESET_LOADING_PROGRESS);
    commit(STORE_FETCHED_ERROR, error);
    console.log(error);
  });
};
// EXTERNAL MODULE: ./src/store/getters.js
var getters = __webpack_require__("UjVw");
var getters_default = /*#__PURE__*/__webpack_require__.n(getters);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/modules/hub.js


var _mutations;

// import api from '../../api'


// initial state
var state = {
  error: null,
  notice: null,
  loading: true,
  loading_progress: 0

  // getters
};var hub_getters = {
  isLoading: function isLoading(state) {
    return state.loading_progress < 100;
  },
  loadingProgress: function loadingProgress(state) {
    return state.loading_progress;
  },
  loadingIncrement: function loadingIncrement(state) {
    return 100 / window.SETTINGS.LOADING_SEGMENTS;
  },
  error: function error(state) {
    return state.error;
  }

  // actions
};var actions = {
  clearError: function clearError(_ref) {
    var commit = _ref.commit;

    commit(STORE_CLEAR_ERROR);
  },
  resetLoading: function resetLoading(_ref2) {
    var commit = _ref2.commit;

    commit(RESET_LOADING_PROGRESS);
  }
};

// mutations
var mutations = (_mutations = {}, defineProperty_default()(_mutations, INCREMENT_LOADING_PROGRESS, function (state, val) {
  state.loading_progress = Math.min(state.loading_progress + hub_getters.loadingIncrement(), 100);
}), defineProperty_default()(_mutations, RESET_LOADING_PROGRESS, function (state) {
  state.loading_progress = 0;
}), defineProperty_default()(_mutations, STORE_CLEAR_ERROR, function (state) {
  state.error = null;
}), defineProperty_default()(_mutations, STORE_FETCHED_ERROR, function (state, error) {
  state.error = error;
}), _mutations);

/* harmony default export */ var hub = ({
  state: state,
  getters: hub_getters,
  actions: actions,
  mutations: mutations
});
// CONCATENATED MODULE: ./src/store/modules/user.js


var user__mutations;

// import api from '../../api'


// initial state
var user_state = {
  id: '',
  logged_in: false

  // getters
};var user_getters = {
  userId: function userId(state) {
    return state.id;
  },
  loggedIn: function loggedIn(state) {
    return state.logged_in;
  }

  // actions
};var user_actions = {
  resetUser: function resetUser(_ref) {
    var commit = _ref.commit;

    commit(LOGOUT_USER);
  }
};

// mutations
var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, STORE_FETCHED_USER, function (state, uid) {
  state.id = uid;
}), defineProperty_default()(user__mutations, LOGIN_USER, function (state) {
  state.logged_in = true;
}), defineProperty_default()(user__mutations, LOGOUT_USER, function (state) {
  state.logged_in = false;
  state.id = '';
}), user__mutations);

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: user_getters,
  actions: user_actions,
  mutations: user_mutations
});
// CONCATENATED MODULE: ./src/store/index.js









vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

var localStorage = dist_default()({
  namespace: 'SMOLIN_BUDGETPLAN_WEBSITE',
  initialState: {},
  expires: 1.21e+9 // Two Weeks
});

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  actions: actions_namespaceObject,
  getters: getters,
  modules: {
    hub: hub,
    user: modules_user
  },
  strict: debug,
  plugins: []
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/AlertComponent.vue
//
//
//
//
//
//

/* harmony default export */ var AlertComponent = ({
  name: 'AlertComponent',
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7595914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AlertComponent.vue
var AlertComponent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"error","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n   "+_vm._s(_vm.text)+"\n ")])}
var AlertComponent_staticRenderFns = []
var AlertComponent_esExports = { render: AlertComponent_render, staticRenderFns: AlertComponent_staticRenderFns }
/* harmony default export */ var shared_AlertComponent = (AlertComponent_esExports);
// CONCATENATED MODULE: ./src/components/shared/AlertComponent.vue
function AlertComponent_injectStyle (ssrContext) {
  __webpack_require__("lG7c")
}
var AlertComponent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AlertComponent___vue_template_functional__ = false
/* styles */
var AlertComponent___vue_styles__ = AlertComponent_injectStyle
/* scopeId */
var AlertComponent___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AlertComponent___vue_module_identifier__ = null
var AlertComponent_Component = AlertComponent_normalizeComponent(
  AlertComponent,
  shared_AlertComponent,
  AlertComponent___vue_template_functional__,
  AlertComponent___vue_styles__,
  AlertComponent___vue_scopeId__,
  AlertComponent___vue_module_identifier__
)

/* harmony default export */ var components_shared_AlertComponent = (AlertComponent_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















// import 'jquery-dropdown/jquery-dropdown.css'

// Bootstrap
__webpack_require__("kBzv");

window.SETTINGS = {
  // How many different dispatched actions determine loading progress
  // This is likely determined by how many dispatched actions you have below
  // in the created() method
  LOADING_SEGMENTS: 2,
  API_BASE_PATH: '/wp-json/wp/v2/'
};

vue_esm["a" /* default */].use(vuetify_default.a);

vue_esm["a" /* default */].component('app-alert', components_shared_AlertComponent);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  store: store,
  router: src_router,
  template: '<App/>',
  components: {
    App: src_App
  },
  created: function created() {
    this.$store.commit(RESET_LOADING_PROGRESS);
    firebase["initializeApp"]({
      apiKey: 'AIzaSyDiOGlwWkyoRchjeZbythuuONicCK7aqH4',
      authDomain: 'sbp-website-2018.firebaseapp.com',
      databaseURL: 'https://sbp-website-2018.firebaseio.com',
      projectId: 'sbp-website-2018',
      storageBucket: 'sbp-website-2018.appspot.com'
    });
  }
});

/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rw5h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports) {


// export const cartProducts = state => {
//   return state.cart.added.map(({ id, quantity }) => {
//     const product = state.products.all.find(p => p.id === id)
//     return {
//       title: product.title,
//       price: product.price,
//       quantity
//     }
//   })
// }

/***/ }),

/***/ "XvMX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZkwB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "drmA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hXkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jzQN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kBzv":
/***/ (function(module, exports, __webpack_require__) {

try {
  window._ = __webpack_require__("M4fF");
  window.$ = window.jQuery = __webpack_require__("7t+N");
  window.axios = __webpack_require__("mtWM");
  window.axios.defaults.headers.common = {
    // 'X-CSRF-TOKEN': window.WordPress.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
  };
} catch (e) {
  console.error(e);
}

/***/ }),

/***/ "lG7c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r2C7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sJil":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1a21a0323ec21a720700.js